<script>
  import {
    VApp
  } from 'vuetify/lib'
  export default {
    name: 'wh-app',
    extends: VApp
  };
</script>